import React, {Component} from 'react';
import LineItem from './LineItem';
import { Link } from 'preact-router/match';

class Cart extends Component {
  constructor(props) {
  super(props);

    this.openCheckout = this.openCheckout.bind(this);
  }

  openCheckout() {
    window.open(this.props.checkout.webUrl);
  }

  render() {
    let line_items = []
    
    if (this.props.checkout && this.props.checkout.lineItems) {
      line_items = this.props.checkout.lineItems.edges.map((line_item) => {
        return (
          <LineItem
            removeLineItemInCart={this.props.removeLineItemInCart}
            updateLineItemInCart={this.props.updateLineItemInCart}
            key={line_item.node.id.toString()}
            line_item={line_item.node}
          />
        );
      });
    }
    

    return (
      <div>          {line_items.length && <button  class="clrBtnOut" onClick={this.props.clearCheckout}  >
      <div> Clear</div> 
      </button> || null}
      <div className={`Cart ${this.props.isCartOpen ? 'Cart--open' : ''}`}>
          
          <button
            onClick={this.props.handleCartClose}
            className="Cart__close">
            close
          </button>
        {line_items.length && <button  class="clrBtn" onClick={this.props.clearCheckout} >
        <div> Clear cart</div> 
        </button>}
        <footer className="Cart__footer">
          <div className="Cart-info clearfix text-center">
  
            <div className="Cart-info__pricing "><small>Total</small><br />
              <div className="pricing">$ {this.props.checkout.totalPrice} </div>
             <div> <small> taxes&shipping at checkout</small></div>
        
            </div>
          </div>
          <button className="Cart__checkout button" onClick={this.openCheckout}>Checkout</button>
        </footer>
        <ul className="Cart__line-items">
          {line_items}
        </ul>

      </div>
      </div>
    )
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./components/cart/index.js